import React from 'react';
import PropTypes from 'prop-types';

import { SkeletonLoader } from 'common/react/components/SkeletonLoader';

/**
 * Displays a loading state for the Team Lineups Condensed Header.
 *
 * @param teamDisplay.teamDisplay
 * @param teamDisplay  The team(s) to display, i.e. 'both', 'home', or 'away'.
 * @returns The Team Lineups Condensed Header skeleton loader.
 */
export const TLCondensedHeaderSkeleton = ({ teamDisplay }) => {
    return (
        <>
            <div
                className={`team-lineups-condensed-embeddable--skeleton team-lineups-header team-lineups-header--${
                    teamDisplay === `both` ? `both` : `single`
                }`}
            >
                {teamDisplay === 'both' && (
                    <div className="team-lineups-header__details u-hide-from-tablet">
                        <div className="team-lineups-header__name">
                            <SkeletonLoader width={300} />
                        </div>
                    </div>
                )}
                <div className="team-lineups-header__content">
                    <div className="team-lineups-header__logo-wrapper">
                        <div className="team-lineups-header__logo">
                            <SkeletonLoader />
                        </div>
                    </div>
                    <div className="team-lineups-header__details team-lineups-header__details--skeleton">
                        {teamDisplay === 'both' ? (
                            <>
                                <div className="u-hide-until-tablet">
                                    <SkeletonLoader width={300} height={24} />
                                    <SkeletonLoader width={300} height={18} />
                                    <SkeletonLoader width={300} height={18} />
                                </div>
                                <div className="u-hide-from-tablet">
                                    <SkeletonLoader width={300} height={18} />
                                    <SkeletonLoader width={300} height={16} />
                                    <SkeletonLoader width={300} height={16} />
                                </div>
                            </>
                        ) : (
                            <>
                                <div className="u-hide-until-tablet">
                                    <SkeletonLoader width={300} height={24} />
                                    <SkeletonLoader width={300} height={18} />
                                    <SkeletonLoader width={300} height={18} />
                                </div>
                                <div className="u-hide-from-tablet">
                                    <SkeletonLoader width={300} height={18} />
                                    <SkeletonLoader width={300} height={16} />
                                    <SkeletonLoader width={300} height={16} />
                                    <SkeletonLoader width={300} height={16} />
                                </div>
                            </>
                        )}
                    </div>
                    {teamDisplay === 'both' && (
                        <div className="team-lineups-header__logo-wrapper">
                            <div className="team-lineups-header__logo">
                                <SkeletonLoader />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
};

TLCondensedHeaderSkeleton.propTypes = {
    teamDisplay: PropTypes.string.isRequired
};
